import { StyledRoot } from "./styled";
import { IChatRootProps } from "./types";

const Root = (props: IChatRootProps)=>{
    return (
        <StyledRoot {...props}/>
    )
}

export {Root}